<template>
  <div class="member_card" >
    <el-divider content-position="left">公司园区管理</el-divider>
    <el-row style="margin-bottom: .4rem">
      <el-col>
        <el-button type="primary" size="small" @click="handleAddOpenAccountArea">新增</el-button>
        <el-button type="primary" size="small" @click.native="$router.push('setting_panel')">返回上一级</el-button>
      </el-col>
    </el-row>
    <div class="el-col-4" style="margin-bottom: .2rem">
      <el-input v-model="searchArr.parkName" placeholder="请输入园区名称" size="mini" @change="searchSome" clearable></el-input>
    </div>
    <el-table
      :data="companyParkList"
      size="medium"
      border
      style="width: 100%; margin-top: 0.2rem"
      v-cloak
    >
    <el-table-column label="编号" width="80">
        <template slot-scope="scope">
          <!-- <el-tooltip placement="top"> -->
            <span class="count-style">{{ scope.row.id }}</span>
          <!-- </el-tooltip> -->
        </template>
      </el-table-column>
      <el-table-column label="园区名称" width="100">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.areaName" placement="top">
            <span class="count-style">{{ scope.row.areaName }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="园区地址" width="100">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.address" placement="top">
            <span class="count-style">{{ scope.row.address }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="所属区域" width="100">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.areaPidName" placement="top">
            <span class="count-style">{{ scope.row.areaPidName }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button type="info"
              icon="el-icon-edit" size="mini" circle
              @click="handleEditParkData(scope.$index, scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="tr mt-10"
      layout="total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-size="pageOption.pageSize"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <el-drawer title="新增园区" :visible.sync="addParkDrawer" direction="rtl" :before-close="handleCreateOrderClose"
      size="40%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form size="mini">
          <el-form-item label="园区名称">
            <el-input v-model="addData.park_name" type="text"></el-input>
          </el-form-item>
          <el-form-item label="园区地址">
            <el-input v-model="addData.address" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="所属区域">
            <el-select v-model="addData.area_name" placeholder="选择所属区域">
              <el-option v-for="(item, index) in companyParkArea" :key="index" :label="item.areaName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-row class="mt-10 tr">
          <el-button type="primary" size="mini" @click="createCompanyPark">保存</el-button>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="编辑园区" :visible.sync="saveParkDrawer" direction="rtl" :before-close="handleSaveOrderClose"
      size="40%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-form size="mini">
          <el-form-item label="园区名称">
            <el-input v-model="saveData.park_name" type="text"></el-input>
          </el-form-item>
          <el-form-item label="园区地址">
            <el-input v-model="saveData.address" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="所属区域">
            <el-select v-model="saveData.area_name" placeholder="选择所属区域">
              <el-option v-for="(item, index) in companyParkArea" :key="index" :label="item.areaName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-row class="mt-10 tr">
          <el-button type="primary" size="mini" @click="saveCompanyPark">保存</el-button>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'CompanyParkList',
  data () {
    return {

      // 搜索参数
      searchArr: {
        card_no: '',
        is_open: '',
        status: '',
        parkName: ''
      },
      // 表格渲染数据
      companyParkList: [],
      // 所属区域数据
      companyParkArea: [],
      // 分页数据
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 10 // 每页显示条数
      },
      // 添加drawer
      addParkDrawer: false,
      addData: {
        park_name: '',
        area_name: '',
        address: ''
      },
      // 编辑显示
      saveParkDrawer: false,
      saveData: {
        park_name: '',
        area_name: '',
        area_pid: null,
        park_id: null,
        address: ''
      }
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }
      return str
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    // 列表
    getCompanyParkList () {
      this.$axios
        .get(
          '/api/admin/company_park/index?page=' +
            this.pageOption.currentPage + this.searchStr
        )
        .then(res => {
          const { data } = res
          if (data.code === 0) {
            this.companyParkList = data.data.list.data
            this.companyParkArea = data.data.areaPidData
            this.pageOption.total = data.data.list.total
            this.pageOption.currentPage = data.data.list.current_page
          }
        })
    },
    searchSome () {
      this.pageOption.currentPage = 1
      this.getCompanyParkList()
    },
    // 新增
    handleAddOpenAccountArea () {
      this.addParkDrawer = true
    },
    // 新增保存
    createCompanyPark () {
      if (!this.addData.park_name) {
        this.$message.error('请输入园区名称！')
        return
      }
      if (!this.addData.area_name) {
        this.$message.error('请选择所属区域！')
        return
      }
      this.$axios.post('/api/admin/company_park/store', this.addData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getCompanyParkList()
            this.addParkDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    // 编辑
    handleEditParkData (index, row) {
      this.saveParkDrawer = true
      this.saveData.park_name = row.areaName
      this.saveData.area_name = row.areaPidName
      this.saveData.area_pid = row.pid
      this.saveData.park_id = row.id
      this.saveData.address = row.address
    },
    // 编辑保存
    saveCompanyPark () {
      if (!this.saveData.park_name) {
        this.$message.error('请输入园区名称！')
        return
      }
      if (!this.saveData.area_name) {
        this.$message.error('请选择所属区域！')
        return
      }
      this.$axios.post('/api/admin/company_park/update', this.saveData)
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.$message.success(data.msg)
            this.getCompanyParkList()
            this.saveParkDrawer = false
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleCreateOrderClose (done) {
      this.addData.park_name = ''
      this.addData.area_name = ''
      this.addData.address = ''
      done()
    },
    handleSaveOrderClose (done) {
      this.saveData.park_name = ''
      this.saveData.area_name = ''
      this.saveData.area_pid = null
      this.saveData.park_id = null
      this.saveData.address = ''
      done()
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getCompanyParkList()
    }
  },
  mounted () {
    this.getCompanyParkList()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';

[v-cloak] {
  display: none;
}

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}

.member_card >>> .el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.member_card {
  marginLeft();

  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tr {
  text-align: right;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-20 {
  margin-top: 0.4rem;
}

.el-form-item {
  margin-bottom: 0.1rem;
}

.el-form .el-select {
  width: 100%;
}

.el-dialog .el-select {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/CompanyParkList.vue